import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { useCheckout, EmailForm } from 'lib/modules/checkout'
import { captureEmail } from 'modules/listrak'
import { MetaData } from 'components/MetaData'
import { CartOverview } from 'components/CartOverview'
import { ShippingGuestMain } from './components/ShippingGuestMain'
import {
  Container,
  CheckoutLayout,
  CheckoutMain,
  CheckoutAside,
  ContentHeader,
  ShippingFirstContent,
  ShippingFormContainer
} from '../styled'

import { ShippingForm } from './components/Form'

export const Shipping = () => {
  const intl = useIntl()
  const { isLoggedIn } = useCustomer()
  const { requiresShipping } = useCheckout()
  const [firstContentClass, setFirstContentClass] = useState('')
  const [headerTitle, setHeaderTitle] = useState(isLoggedIn ? 'checkout.header.shipping' : 'checkout.account.login')
  const title = intl.formatMessage({ id: 'checkout.title' })

  const handleChangeContentClass = (classValue: string, headerValue: string) => {
    setFirstContentClass(classValue)
    setHeaderTitle(headerValue)
  }

  if (!requiresShipping()) {
    return (
      <Redirect to='/checkout/billing' />
    )
  }

  return (
    <>
      <MetaData
        title={title}
      />
      <Container>
        <h1>{title}</h1>
        <CheckoutLayout>
          <CheckoutMain>
            <ContentHeader>
              <span>{intl.formatMessage({ id: headerTitle })}</span>
            </ContentHeader>

            {!isLoggedIn
              ? (
                <ShippingFirstContent className={firstContentClass}>
                  <ShippingGuestMain setFirstContentClass={handleChangeContentClass} />
                </ShippingFirstContent>
              )
              : (
                <>
                  <EmailForm
                    interceptBlur={(e) => {
                      captureEmail(e.value)
                    }}
                  />
                  <ShippingFormContainer>
                    <ShippingForm />
                  </ShippingFormContainer>
                </>
              )}
          </CheckoutMain>
          <CheckoutAside>
            <ContentHeader>
              <span>{intl.formatMessage({ id: 'checkout.cart.overview' })}</span>
            </ContentHeader>
            <CartOverview />
          </CheckoutAside>
        </CheckoutLayout>
      </Container>
    </>
  )
}
